import React from 'react';
import './css/Politica.css';
import './css/TextPage.css';

const PoliticaPrivacidade: React.FC = () => {
  return (
    <div className="politica-container text-page">
      <h1>Política de Privacidade</h1>
      <p>Esta Política de Privacidade descreve como suas informações pessoais são coletadas, usadas e protegidas ao utilizar nosso site.</p>

      <h2>1. Coleta de Informações</h2>
      <p>Coletamos informações que você nos fornece voluntariamente, como nome, e-mail e informações de contato, ao preencher formulários ou se cadastrar em cursos.</p>

      <h2>2. Uso das Informações</h2>
      <p>Utilizamos seus dados para:</p>
      <ul>
        <li>Fornecer informações sobre cursos e eventos;</li>
        <li>Melhorar sua experiência no site;</li>
        <li>Entrar em contato com você sobre atualizações e serviços;</li>
        <li>Atender a obrigações legais.</li>
      </ul>

      <h2>3. Compartilhamento</h2>
      <p>Não compartilhamos suas informações com terceiros, exceto quando exigido por lei ou com seu consentimento expresso.</p>

      <h2>4. Seus Direitos</h2>
      <p>Você pode solicitar a correção, exclusão ou visualização de seus dados pessoais a qualquer momento.</p>

      <h2>5. Segurança</h2>
      <p>Adotamos medidas de segurança para proteger suas informações contra acessos não autorizados.</p>

      <p>Última atualização: Abril de 2025</p>
    </div>
  );
};

export default PoliticaPrivacidade;
